export enum ContentType {
    TEXT = 'text',
    HIGHLIGHT = 'highlight',
    PICTURE = 'picture',
    VIDEO = 'video',
    QUOTE = 'quote',
    CTA = 'call_to_action',
    AUDIO = 'audio',
}
